export default {
  banner: {
    documentAlt: 'Document Icon',
    stepsToPrepare: 'Two easy steps to prepare for tax season',
    submitYourInfo: 'Submit your tax information',
    request1099: 'Request Form 1099-K',
    step1Alt: 'Step 1',
    step2Alt: 'Step 2',
    explanationHtml: 'If you sell more than $600 in a calendar year, your tax info is needed so we can issue you a Form 1099-K. {{children}}',
  },
  footer: {
    speakerAlt: 'Speaker Icon',
    shieldAlt: 'Shield Icon',
    doINeedToProvideInfoHeader: 'Do I need to provide my tax info?',
    doINeedToProvideInfoParagraph1: 'For sales made in 2022, Reverb is required to collect tax identification information from US sellers who exceed the federal threshold of $20,000 in sales and 200 transactions or live in a state with a lower reporting threshold. You can {{children}}',
    doINeedToProvideInfoLearnMore1: 'learn more about 2022 US tax reporting requirements here.',
    doINeedToProvideInfoParagraph2: 'For sales made in 2023, marketplaces like Reverb are required to collect tax identification information from US sellers who sell $600 or more on the platform in a calendar year. You can {{children}}',
    doINeedToProvideInfoLearnMore2: 'learn more about 2023 US tax reporting requirements here.',
    doINeedToProvideInfoParagraph3: 'This tax information is needed to issue you a Form 1099-K. Once you\'ve provided your tax information, we\'ll reach out to you on any next steps—including when your Form 1099-K is ready to download. Note that reporting your sales doesn\'t necessarily mean you\'ll need to pay income tax on your sales.',
    advocacyHeadline: 'How we\'re advocating for change',
    advocacyParagraph1: 'In December 2022, {{children}} of the $600 1099-K reporting threshold. This means that for the 2022 tax year, you\'ll only receive a Form 1099-K if you exceeded the previous federal threshold or your state\'s threshold.',
    advocacyOneYearDelayLink: 'the IRS announced a one-year delay',
    advocacyParagraph2: 'Thank you for helping us advocate for change. This delay was the result of advocacy by Reverb and other leading online marketplaces to encourage Congress to raise the $600 reporting threshold, which disproportionately burdens casual sellers. More than a thousand Reverb sellers shared their stories about the benefits of reselling used gear on Reverb and those stories resonated with policymakers.',
    advocacyParagraph3: 'While the {{children}}, we\'re hopeful that this delay is the first step toward a permanent solution. We\'ll continue to advocate on behalf of the Reverb community and keep you updated along the way. ',
    advocacyThresholdOnHold: '$600 reporting threshold is currently in effect for 2023 sales',
  },
  tinVerification: {
    incomplete: 'Incomplete',
    complete: 'Complete',
    pending: 'Pending',
  },
  taxForms: {
    comingSoon: 'Coming soon: if you exceeded federal or state tax reporting thresholds in {{prevYear}}, your Form 1099-K will be available here at the end of January {{currYear}}.',
    noFormsAvailable: 'No tax forms available. You didn\'t meet the 1099-K reporting threshold for {{prevYear}}.',
    downloadTaxForm: 'Download',
    failure: 'Something went wrong downloading your tax form.  Please try again.',
    loading: 'Fetching Form...',
    requestDownload: 'Request Form',
    requested: 'Form 1099-K successfully requested! A download link to your Form 1099-K will be available below shortly.',
    secureDownload: 'For your security, this link will expire after 24 hours.',
    title: 'Request Form 1099-K',
    description: 'If you prefer a paper Form 1099-K mailed to you, please email {{children}}.',
    emailLinkText: '1099taxreporting@reverb.com',
    downloadIncompleteStatus: 'Incomplete',
    downloadRequestedStatus: 'Last requested on {{date}}',
    downloadNotYetRequested: 'This form has not been requested yet.',
    taxYear: 'Tax Year',
    taxYearStatus: 'Status',
  },
  helpCenterLinkText: 'Learn more in our Help Center.',
  taxProfileForm: {
    tinFailedVerificationHeadline: 'Important: Updated tax info needed',
    tinFailedVerificationMessage: 'Your TIN was not able to be verified. Please double check that the information you provided matches what you used to file your taxes.',
  },
};
